<template>
  <div>
    <table class="table table-borderless table-striped">
      <tbody>
        <tr
          v-for="(location, l) of rowData.workLocations.slice(1)"
          :key="l"
        >
          <td
            v-for="(field, f) of options.fields"
            :key="f"
            :class="field.dataClass"
          >
            <template
              v-if="field.name === 'workLocations'"
              class="d-flex"
            >
              {{ location.name }}
              <a
                v-if="options.permission.permissions.includes('edit')"
                class="mx-2"
                @click="showModal('editCp', rowData.id, location.id)"
              >
                <img
                  src="@/assets/icon/pencil.png"
                  alt="edit"
                >
              </a>
            </template>

            <template v-if="field.name === 'contact'">
              <div
                v-for="(contact, c) of location.contactPersons"
                :key="c"
              >
                {{ contact.type }}: {{ contact.name }} ({{ contact.phoneNumber }})
              </div>
            </template>

            <template v-if="field.name === 'email'">
              <div
                v-for="(contact, c) of location.contactPersons"
                :key="c"
              >
                {{ contact.email }}
              </div>
            </template>

            <template v-if="field.name === 'siteAdmin'">
              <div
                v-for="(user, u) of location.users"
                :key="u"
              >
                {{ user.fullname }}
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <modal-edit-cp
      v-if="modal.editCp"
      :id="modal.id"
      :information-id="modal.informationId"
      :permission="options.permission"
      @close="closeModal"
    />
  </div>
</template>

<script>
import ModalEditCp from './ModalEditCp'

export default {
  components: {
    ModalEditCp
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    modal: {
      id: '',
      editCp: false
    }
  }),

  methods: {
    showModal (modalname, dataId, informationId) {
      this.modal.id = dataId
      this.modal.informationId = informationId
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal.id = null
      this.modal[modalname] = false
    }
  }
}
</script>
